import {refreshUserProperties} from '../../services/analytics/jitsu-helpers';
import hiveSDK from '../../services/hive-sdk';
import {
  getAccessToken,
  getRefreshToken,
  isTokenValid
} from '../../services/tokens';
import {setAuthorizationDataAndUserId} from '../../services/user-id-helpers';

const refreshUserToken = async (shouldForceUpdate = true) => {
  const refreshToken = getRefreshToken();

  if (refreshToken) {
    const accessToken = getAccessToken();

    if (shouldForceUpdate || !isTokenValid(accessToken)) {
      return hiveSDK.refresh(
        {refresh_token: refreshToken},
        async response => {
          setAuthorizationDataAndUserId(response);
          const user = await window.userMemoryRepository.update();

          refreshUserProperties(user);
        },
        () => {},
        accessToken
      );
    }

  }
};

export {refreshUserToken};
